export default __webpack_public_path__ + "static/home-hero1-bd154123c2f10b4ff9c5e4a84aab093f.jpg";